import "./OrchesChoose.css";
import img from "../orchesassets/choose.png";
import chooseimg from "../orchesassets/chooseimg.png";

const chooseList = [
  {
    title: "Proven DevOps & Kubernetes Expertise",
    description:
      "Extensive experience managing large-scale, distributed systems.",
  },
  {
    title: "Secure & Compliant Solutions",
    description:
      "Orchestration frameworks aligned with enterprise and healthcare standards.",
  },
  {
    title: "Customized Orchestration Strategies",
    description:
      "Tailored solutions aligned with your application architecture and business objectives.",
  },
  {
    title: "Focus on Reliability & Performance",
    description:
      "Designs built for operational excellence and consistent system performance.",
  },
];

export default function OrchesChoose() {
  return (
    <div id="orches-choose" className="outsourcemainclass">
      <div className="choose-container">
        <div className="left">
          <img src={img} alt="error" />
        </div>

        <div className="right">
          <h3>Why Choose BastionEx for Orchestration?</h3>
          <p>Delivering Secure, Scalable, and Enterprise-Grade Orchestration</p>

          <ul>
            {chooseList.map((item, index) => (
              <li key={index}>
                <p>
                  <img src={chooseimg} alt="" className="choose-icon" />
                 {item.title}
                </p>
                {item.description}
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
}
